import { createApi } from '@core/fetch'

export default {
  cardCouponList: createApi(
    '/p/wedding/index.php/Admin/APIMerchantCouponBuyers/MerchantCouponList'
  ),
  exchangeCoupon: createApi(
    '/p/wedding/index.php/Admin/APIMerchantCouponBuyers/ReceiveCoupon'
  ),
  couponPoster: createApi(
    '/p/wedding/index.php/Home/APIPosterBlock/merchant_coupon_posters'
  )
}
